<template>
  <div class="page-component-wrapper">
    <grid :config="gridConfig"/>
    <modal-new :config="{id: gridConfig.id, api: 'StockSalesRemarks/Get/'}"/>
  </div>
</template>

<script>
import gridConfig from './GridConfig'

export default {
  name: 'StockSalesRemarksIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'modal-new': () => import(/* webpackChunkName: 'StockSalesRemarks' */ './ModalNew')
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  }
}
</script>
